import React from 'react';
import {styled} from "@mui/styles";
import TextField from "@mui/material/TextField";
import {useRef, useState} from "react";
import useTimeout from "../utils/useTimeout";
import ShowMessage from "../utils/show-message";
import {validateEmail} from "../utils/cert-helper";
import {ApiUrl} from "../utils/portal-urls";
import {handleHttpResponse} from "../utils/http-helpers";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Grow, Zoom} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import Slide from "@mui/material/Slide";


const StyledTextField = styled(TextField)({
    marginBottom: 10,
})
export const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction='up' timeout={500} ref={ref} {...props}/>
})
const alertLevelList = ['None', 'Error', 'Info', 'Verbose'];
const userTypeList = ['None', 'Admin', 'User'];

export default function OrganizationUserAddDialog(props) {
    const dialogRef = useRef(null);
    const title = props.title
    const userType = props.user.userType;
    const onRefresh = props.onRefresh;
    const users = props.pageResult;

    const [loading, setLoading] = useState(false);
    const [msg, setMsg] = useState({});
    const [alertLevel, setAlertLevel] = useState("");
    const [selectedUserType, setSelectedUserType] = useState("");
    const [tokenLink, setTokenLink] = useState();
    const [errorEmailMsg, setErrorEmailMsg] = useState("");

    const handleClose = () => {
        const dialogForm = dialogRef.current;
        setErrorEmailMsg("");
        if (dialogForm.firstName.value && dialogForm.lastName.value && dialogForm.email.value && !errorEmailMsg.length) {
            props.close(false)
        }
    };

    const isEmailExist = (email) => {
        let exist;
        if (users) {
            exist = users.filter( u => u.email === email);
        }
        return exist.length > 0;
    }

    const handleCancel = () => {
        setErrorEmailMsg("");
        props.close(false);
    }

    const DialogAlert = () => {
        useTimeout(() => setMsg({}), 5000);
        return <ShowMessage msg={msg} />
    }

    const handleAlertLevelChange = (event) => {
        let level = event.target.value;
        if (level === 'None') {
            setAlertLevel("");
        } else {
            setAlertLevel(level);
        }
    }

    const handleUserTypeChange = (event) => {
        const type = event.target.value;
        if (type === 'None') {
            setSelectedUserType("");
        } else {
            setSelectedUserType(type);
        }
    }

    const handleEmailChange = () => {
        const input= dialogRef.current.email.value;
        if ( !validateEmail(input)) {
            setErrorEmailMsg("Please provide a valid email address");
        } else {
            if (isEmailExist(input)) {
                setErrorEmailMsg("This Email Address has been taken")
            } else {
                setErrorEmailMsg("");
            }
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        const form = {}
        const dialogForm = dialogRef.current;

        form["givenName"] = dialogForm.firstName.value;
        form["familyName"] = dialogForm.lastName.value;
        if (errorEmailMsg.length) {
            return;
        }
        form["email"] = dialogForm.email.value;
        form["phone"] = dialogForm.phone.value;
        form["alertLevel"] = alertLevel;
        userType && userType === "admin" && (form["userType"] = selectedUserType.toLowerCase());

        props.setNewUser(form);

        console.info(form);

        const requestOption = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(form)
        }

        const url = ApiUrl.Users.addUser.getPath();
        const userFullName = `${form['givenName']} ${form['familyName']}`;

        console.log("OrganizationUserAddDialog: ");
        console.log("Post request: " + url);


        try {
            setLoading(true);
            const res = await fetch(url, requestOption)
            const data = await handleHttpResponse(res);
            onRefresh(new Date().getTime());
            setMsg({succ: `Successfully ${title} the user: ${userFullName}`});
            setSelectedUserType("");
            props.setTokenLink(data.linkUri);
            props.setSlideDialogOpen(true);
        } catch (err) {
            console.error(`Failed to POST the request: `, err);
            if (err) {
                setMsg({error: `Unable to ${title} the user: ${userFullName}`})
                console.error(err);
            }
        } finally {
            setLoading(false);
        }

        setAlertLevel("");
    }

    return (
        <div>
            {msg && <DialogAlert/> }

            <Dialog
                open={props.open}
                onClose={handleClose}
                PaperProps={{style: {borderRadius: 12}}}
                TransitionComponent={Transition}
            >
                <DialogTitle color="white"
                             sx={{backgroundColor: "rgba(60,120,185,1)"}}
                >
                    Add User
                </DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSubmit} id='userAddForm' ref={dialogRef}>
                        <StyledTextField
                            required
                            sx={{mt: "10px"}}
                            autoComplete="off"
                            id="firstName"
                            label="First Name"
                            fullWidth
                            variant="standard"
                        />
                        <StyledTextField
                            required
                            autoComplete="off"
                            id="lastName"
                            label="Last Name"
                            fullWidth
                            variant="standard"
                        />
                        <StyledTextField
                            required
                            autoComplete="off"
                            id="email"
                            label="Email"
                            fullWidth
                            variant="standard"
                            onChange={handleEmailChange}
                            error={!!errorEmailMsg.length}
                            helperText={errorEmailMsg}
                        />
                        <StyledTextField
                            autoComplete="off"
                            id="phone"
                            label="Phone"
                            fullWidth
                            variant="standard"
                        />
                        <StyledTextField
                            autoComplete='off'
                            select
                            onChange={handleAlertLevelChange}
                            id='alertLevel'
                            label='Alert Level'
                            value={alertLevel}
                            fullWidth
                            variant='standard'
                        >
                            {alertLevelList.map((a, i) => (
                                <MenuItem key={i} value={a}>
                                    {a}
                                </MenuItem>
                            ))}
                        </StyledTextField>
                        {userType && userType === "admin" &&
                            <StyledTextField
                                autoComplete="off"
                                select
                                onChange={handleUserTypeChange}
                                id="userType"
                                label="User Type"
                                fullWidth
                                value={selectedUserType}
                                variant="standard"
                            >
                                {userTypeList.map((u, i) => (
                                    <MenuItem key={i} value={u}>
                                        {u}
                                    </MenuItem>
                                ))}
                            </StyledTextField>
                        }
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancel} variant="outlined">Cancel</Button>
                    <Button type="submit" form='userAddForm' onClick={handleClose} variant="contained">Submit</Button>
                </DialogActions>
            </Dialog>

            <Backdrop sx={{zIndex: theme => theme.zIndex.drawer + 1, color: "#fff"}} open={loading} >
                <CircularProgress color={"inherit"}/>
            </Backdrop>
        </div>
    );
}
